import { forwardRef } from "react";
import Banner from "../components/Banner";
import "./styles.css"

const Home = forwardRef((props, ref) => (

    <section className="home" ref={ref}>
        <Banner />
    </section>
));

export default Home